<template>
  <form ref="form" autocomplete="off" class="tf" @submit.prevent>
    <ValidationObserver ref="observer" v-slot="{}">
      <div class="tf-row">
        <span class="tf-label">Service *</span>
        <ValidationProvider v-slot="{ errors }" rules="required" name="service" ref="invoice_service">
          <input v-model="invoice_service" class="tf-input" :class="{ error: errors.length }" placeholder="Service name" @keypress="onKeyPress"/>
          <span v-if="errors.length" class="tf-error">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
      <div class="tf-row">
        <span class="tf-label">Description</span>
        <ValidationProvider v-slot="{ errors }" name="description" ref="invoice_description">
          <input v-model="invoice_description" class="tf-input" :class="{ error: errors.length }" placeholder="Description" @keypress="onKeyPress"/>
        </ValidationProvider>
      </div>
      <div class="tf-grid">
        <div class="tf-row" style="flex: 1">
          <span class="tf-label">Qty</span>
          <ValidationProvider v-slot="{ errors }" name="quantity" ref="invoice_quantity">
            <input v-model="invoice_quantity" class="tf-input" :class="{ error: errors.length }" placeholder="1" @keypress="onlyNumber"/>
          </ValidationProvider>
        </div>
        <div class="tf-row" style="flex: 1">
          <span class="tf-label">Rate * ($)</span>
          <ValidationProvider v-slot="{ errors }" name="rate" ref="invoice_rate">
            <input v-model="invoice_rate" class="tf-input" :class="{ error: errors.length }" placeholder="0.00" @keypress="onlyNumber"/>
          </ValidationProvider>
        </div>
        <div class="tf-row" style="flex: 1">
          <span class="tf-label">Tax %</span>
          <ValidationProvider v-slot="{ errors }" name="tax" ref="invoice_tax">
            <input v-model="invoice_tax" class="tf-input" :class="{ error: errors.length }" placeholder="0" @keypress="onlyNumber"/>
          </ValidationProvider>
        </div>
      </div>

      <div class="tf-divider"></div>

      <div class="tf-row">
        <span class="tf-label">Customer Name *</span>
        <ValidationProvider v-slot="{ errors }" rules="required" name="customer_name" ref="invoice_customer_name">
          <input v-model="invoice_customer_name" class="tf-input" :class="{ error: errors.length }" placeholder="Full name" @keypress="onKeyPress"/>
          <span v-if="errors.length" class="tf-error">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
      <div class="tf-row">
        <span class="tf-label">Customer Address</span>
        <ValidationProvider v-slot="{ errors }" name="customer_address" ref="invoice_customer_address">
          <input v-model="invoice_customer_address" class="tf-input" :class="{ error: errors.length }" placeholder="Address" @keypress="onKeyPress"/>
        </ValidationProvider>
      </div>
      <div class="tf-grid">
        <div class="tf-row" style="flex: 1">
          <span class="tf-label">Phone</span>
          <ValidationProvider v-slot="{ errors }" name="customer_phone" ref="invoice_customer_phone">
            <input v-model="invoice_customer_phone" class="tf-input" :class="{ error: errors.length }" placeholder="Phone" maxlength="10" @keypress="onKeyPress"/>
          </ValidationProvider>
        </div>
        <div class="tf-row" style="flex: 1">
          <span class="tf-label">Email</span>
          <ValidationProvider v-slot="{ errors }" name="customer_email" ref="invoice_customer_email">
            <input v-model="invoice_customer_email" class="tf-input" :class="{ error: errors.length }" placeholder="Email" @keypress="onKeyPress"/>
          </ValidationProvider>
        </div>
      </div>
      <div class="tf-row">
        <span class="tf-label">Notes</span>
        <ValidationProvider v-slot="{ errors }" name="notes" ref="invoice_notes">
          <input v-model="invoice_notes" class="tf-input" :class="{ error: errors.length }" placeholder="Notes" @keypress="onKeyPress"/>
        </ValidationProvider>
      </div>

      <div class="tf-totals">
        <div class="tf-total-row">
          <span>Subtotal</span>
          <span>${{ invoice_subtotal }}</span>
        </div>
        <div class="tf-total-row tf-muted">
          <span>Tax</span>
          <span>{{ invoice_tax || 0 }}%</span>
        </div>
        <div class="tf-total-row tf-bold">
          <span>Total</span>
          <span>${{ invoice_total }}</span>
        </div>
      </div>
    </ValidationObserver>
  </form>
</template>
<script>
import {ValidationObserver, ValidationProvider} from 'vee-validate'

export default {
  props: {
    chat_id: {
      type: String,
      default: ""
    },
    message_send: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    nowDate: new Date().toISOString().slice(0, 10),
    invoice_service: null,
    invoice_description: null,
    invoice_quantity: null,
    invoice_rate: null,
    invoice_tax: null,
    invoice_uPrice: null,
    invoice_customer_name: null,
    invoice_customer_address: null,
    invoice_customer_phone: null,
    invoice_customer_email: null,
    invoice_notes: null,
    v: {
      service: null,
      description: null,
      quantity: null,
      rate: null,
      tax: null,
      uPrice: null,
      customer_name: null,
      customer_address: null,
      customer_phone: null,
      customer_email: null,
      notes: null,

    },

  }),
  watch: {
    async invoice_service() {
        const self = this;
        self.v.service = await self.$refs.invoice_service.validate();
        self.v.service = self.v.service.valid;
        self.validate_inputs();
    },
    async invoice_description() {
      const self = this;
      self.v.description = await self.$refs.invoice_description.validate();
      self.v.description = self.v.description.valid;
      self.validate_inputs();
    },
    async invoice_quantity() {
      const self = this;
      self.v.quantity = await self.$refs.invoice_quantity.validate();
      self.v.quantity = self.v.quantity.valid;
      self.validate_inputs();
    },
    async invoice_tax() {
        const self = this;
        self.v.tax = await self.$refs.invoice_tax.validate();
        self.v.tax = self.v.tax.valid;
        self.validate_inputs();
    },
    async invoice_rate() {
        const self = this;
        self.v.rate = await self.$refs.invoice_rate.validate();
        self.v.rate = self.v.rate.valid;
        self.validate_inputs();
    },
    async invoice_uPrice() {
      const self = this;
      if (self.$refs.invoice_uPrice) {
        self.v.uPrice = await self.$refs.invoice_uPrice.validate();
        self.v.uPrice = self.v.uPrice.valid;
      }
      self.validate_inputs();
    },
      async invoice_customer_name() {
          const self = this;
          self.v.customer_name = await self.$refs.invoice_customer_name.validate();
          self.v.customer_name = self.v.customer_name.valid;
          self.validate_inputs();
      },
      async invoice_customer_address() {
          const self = this;
          self.v.customer_address = await self.$refs.invoice_customer_address.validate();
          self.v.customer_address = self.v.customer_address.valid;
          self.validate_inputs();
      },
      async invoice_customer_phone() {
          const self = this;
          self.v.customer_phone = await self.$refs.invoice_customer_phone.validate();
          self.v.customer_phone = self.v.customer_phone.valid;
          self.validate_inputs();
      },
      async invoice_customer_email() {
          const self = this;
          self.v.customer_email = await self.$refs.invoice_customer_email.validate();
          self.v.customer_email = self.v.customer_email.valid;
          self.validate_inputs();
      },
      async invoice_notes() {
          const self = this;
          self.v.notes = await self.$refs.invoice_notes.validate();
          self.v.notes = self.v.notes.valid;
          self.validate_inputs();
      },
    message_send(update) {
      if (update) {
        this.invoice_service = null;
        this.invoice_description = null;
        this.invoice_quantity = null;
        this.invoice_rate = null;
        this.invoice_tax = null;
        this.invoice_customer_name = null;
        this.invoice_customer_address = null;
        this.invoice_customer_phone = null;
        this.invoice_customer_email = null;
        this.invoice_notes = null;
        Object.keys(this.v).forEach(k => this.v[k] = null);
      }
    },
    defaultValue: {
      handler(val) {
        if (val && Object.keys(val).length > 0) {
          //
        }
      },
      deep: true
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  created() {
    if (this.defaultValue && Object.keys(this.defaultValue).length > 0) {
      this.init();
    }
  },
  computed: {
    invoice_total() {
      let sub_total = 0;
      if (isNaN(parseFloat(this.invoice_quantity))){
          sub_total = parseFloat(this.invoice_rate);
      }else{
          sub_total = parseFloat(this.invoice_quantity) * parseFloat(this.invoice_rate);
      }
      let total =   sub_total + (sub_total * (parseFloat(this.invoice_tax) / 100));
      if (isNaN(total)){
          if (isNaN(sub_total)){
              total = 0;
          }else{
              total = sub_total;
          }
      }
      return total.toFixed(2);
    },
    invoice_subtotal() {
      let sub_total = 0;
      if (isNaN(parseFloat(this.invoice_quantity))){
          sub_total = parseFloat(this.invoice_rate);
      }
      if (!isNaN(parseFloat(this.invoice_quantity)) && !isNaN(parseFloat(this.invoice_rate))){
          sub_total = parseFloat(this.invoice_quantity) * parseFloat(this.invoice_rate);
      }
      if (isNaN(sub_total)){
          sub_total = 0;
      }
      return sub_total;
    },
  },
  methods: {
    init() {
      this.invoice_service = this.defaultValue.invoice.service;
      this.invoice_description = this.defaultValue.invoice.description;
      this.invoice_customer_name = this.defaultValue.invoice.customer_name;
      this.invoice_customer_address = this.defaultValue.invoice.customer_address;
      this.invoice_customer_phone = this.defaultValue.invoice.customer_phone;
      this.invoice_customer_email = this.defaultValue.invoice.customer_email;
      this.invoice_notes = this.defaultValue.invoice.notes;
      this.invoice_quantity = this.defaultValue.invoice.quantity;
      this.invoice_rate = this.defaultValue.invoice.rate;
      this.invoice_tax = this.defaultValue.invoice.tax;

      this.v.service = true;
      this.v.description = true;
      this.v.quantity = true;
      this.v.rate = true;
      this.v.tax = true;
      this.v.uPrice = true;
      this.v.customer_name = true;
      this.v.customer_address = true;
      this.v.customer_phone = true;
      this.v.customer_email = true;
      this.v.notes = true;

      this.validate_inputs();
    },
    async onKeyPress(event) {
      const self = this;
      if (event.key === "Enter") {
        self.$emit("pressEnter");
      }
    },
    onlyNumber($event) {
      const self = this;
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57 || keyCode == 46) {
        $event.preventDefault();
      }
      if ($event.key === "Enter") {
        self.$emit("pressEnter");
      }
    },
    onlyDecimal($event) {
      const self = this;
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 46 || keyCode > 57 || keyCode == 47) {
        $event.preventDefault();
      }
      if ($event.key === "Enter") {
        self.$emit("pressEnter");
      }
    },
    setter(isValid) {
      const self = this;
      var param = {
        type: 'invoice',
        message: {
          chat_id: self.chat_id,
          service: self.invoice_service,
          description: self.invoice_description,
          customer_name: self.invoice_customer_name,
          customer_address: self.invoice_customer_address,
          customer_phone: self.invoice_customer_phone,
          customer_email: self.invoice_customer_email,
          notes: self.invoice_notes,
          quantity: (self.invoice_quantity !== null) ? parseInt(self.invoice_quantity): 1,
          rate: parseFloat(this.invoice_rate),
          tax: parseFloat(this.invoice_tax),
          total: self.invoice_total,
          type: 'invoice',
        },
        isValid: isValid,
      };

      self.$emit("setter", param);
    },
    async validate_inputs() {
      const self = this;
      var isValid = false;
      if (self.v.rate && self.v.service && self.v.customer_name) {
        isValid = true;
      }
      self.setter(isValid);
    },
  },

}
</script>
<style scoped lang="scss">
@import '../_variables';

.tf {
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 320px;
  overflow-y: auto;
  // ValidationObserver renders as <span> — make it block
  > span { display: flex; flex-direction: column; gap: 6px; }
}

.tf-row {
  display: flex;
  flex-direction: column;
  gap: 2px;
  span { display: block; }
}

.tf-grid {
  display: flex;
  gap: 8px;
}

.tf-label {
  font-size: 10px;
  font-weight: 600;
  color: $t3;
  font-family: $font;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.tf-input {
  width: 100%;
  height: 28px;
  padding: 0 8px;
  border: 1px solid $border;
  border-radius: 6px;
  background: #fff;
  font-size: 11px;
  font-family: $font;
  color: $t1;
  outline: none;
  transition: border-color 0.15s;
  &::placeholder { color: $t4; }
  &:focus { border-color: $accent; }
  &.error { border-color: #ff3b30; }
}

.tf-error {
  font-size: 10px;
  color: #ff3b30;
  font-family: $font;
}

.tf-divider {
  height: 1px;
  background: $border;
  margin: 4px 0;
}

.tf-totals {
  background: $bg-input;
  border-radius: 8px;
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.tf-total-row {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  font-family: $font;
  color: $t2;
  &.tf-muted { color: $t3; }
  &.tf-bold { font-weight: 700; color: $t1; border-top: 1px solid $border; padding-top: 4px; margin-top: 2px; }
}

@media (max-width: 480px) {
  .tf { padding: 5px 8px; gap: 4px; max-height: 240px; > span { gap: 4px; } }
  .tf-label { font-size: 8px; }
  .tf-input { height: 24px; font-size: 10px; padding: 0 6px; border-radius: 5px; }
  .tf-grid { gap: 4px; }
  .tf-error { font-size: 8px; }
  .tf-totals { padding: 5px 8px; border-radius: 6px; }
  .tf-total-row { font-size: 9px; }
}
@media (max-width: 360px) {
  .tf { padding: 3px 5px; gap: 3px; max-height: 180px; > span { gap: 3px; } }
  .tf-label { font-size: 7px; }
  .tf-input { height: 20px; font-size: 9px; padding: 0 4px; border-radius: 4px; }
  .tf-grid { gap: 3px; }
  .tf-error { font-size: 7px; }
  .tf-totals { padding: 3px 5px; border-radius: 5px; }
  .tf-total-row { font-size: 8px; }
}
@media (max-width: 280px) {
  .tf { padding: 2px 3px; gap: 2px; max-height: 140px; > span { gap: 2px; } }
  .tf-label { font-size: 6px; }
  .tf-input { height: 18px; font-size: 8px; padding: 0 3px; }
  .tf-totals { padding: 2px 3px; }
  .tf-total-row { font-size: 7px; }
}
</style>
